import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || '';
// Use relative URL in production (custom domain), absolute in preview
const isPreview = BACKEND_URL.includes('preview.emergentagent.com');
export const API = isPreview ? `${BACKEND_URL}/api` : '/api';

export const api = axios.create({
  baseURL: API,
});

export const setAuthToken = (token) => {
  if (token) {
    api.defaults.headers.common['Authorization'] = `Bearer ${token}`;
  } else {
    delete api.defaults.headers.common['Authorization'];
  }
};

// Global interceptor: send X-Tenant-ID and Authorization headers
axios.interceptors.request.use((config) => {
  try {
    const adminData = localStorage.getItem('admin_data');
    if (adminData) {
      const parsed = JSON.parse(adminData);
      if (parsed.tenant_id) {
        config.headers['X-Tenant-ID'] = parsed.tenant_id;
      }
    }
    const atelier = JSON.parse(localStorage.getItem('atelier_employee') || 'null');
    if (!config.headers['X-Tenant-ID'] && atelier?.tenant_id) config.headers['X-Tenant-ID'] = atelier.tenant_id;
    const path = window.location.pathname;
    const mobileToken = (path.startsWith('/reception-mobile') && sessionStorage.getItem('mobile_checkin_token')) || (path.startsWith('/restitution-mobile') && sessionStorage.getItem('mobile_checkout_token'));
    if (mobileToken) { config.headers['Authorization'] = `Bearer ${mobileToken}`; return config; }
    const onAtelier = window.location.pathname.startsWith('/atelier') && atelier?.token;
    if (onAtelier && atelier.tenant_id) config.headers['X-Tenant-ID'] = atelier.tenant_id;
    const token = onAtelier ? atelier.token : (localStorage.getItem('admin_token') || localStorage.getItem('employee_token') || localStorage.getItem('superadmin_token') || atelier?.token);
    if (token && !config.headers['Authorization']) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
  } catch (e) { /* ignore */ }
  return config;
});

// Global response interceptor: handle 403 upgrade_required
axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 403 && error.response?.data?.detail?.error === 'upgrade_required') {
      const detail = error.response.data.detail;
      const planLabels = { trial: 'Essai', starter: 'Starter', business: 'Business', enterprise: 'Enterprise', enterprise_plus: 'Enterprise+' };
      const msg = `Cette fonctionnalite necessite le plan ${planLabels[detail.required_plan] || detail.required_plan} ou superieur. Votre plan actuel: ${planLabels[detail.current_plan] || detail.current_plan}`;
      // Dispatch custom event for toast
      window.dispatchEvent(new CustomEvent('plan-upgrade-required', { detail: { message: msg, required_plan: detail.required_plan } }));
    }
    return Promise.reject(error);
  }
);

// Get auth headers for PDF downloads
const getAuthHeaders = () => {
  const headers = {};
  try {
    const token = localStorage.getItem('admin_token') || localStorage.getItem('superadmin_token');
    if (token) headers['Authorization'] = `Bearer ${token}`;
    const adminData = localStorage.getItem('admin_data');
    if (adminData) {
      const parsed = JSON.parse(adminData);
      if (parsed.tenant_id) headers['X-Tenant-ID'] = parsed.tenant_id;
    }
  } catch {}
  return headers;
};

// Safe PDF download - uses hidden <a> link with token in query param
// This is the MOST compatible approach across all browsers
export const downloadPdf = async (url, filename) => {
  const token = localStorage.getItem('admin_token') || localStorage.getItem('superadmin_token') || '';
  const separator = url.includes('?') ? '&' : '?';
  const fullUrl = `${url}${separator}token=${encodeURIComponent(token)}`;
  const link = document.createElement('a');
  link.href = fullUrl;
  link.download = filename || 'document.pdf';
  link.target = '_self';
  link.style.display = 'none';
  document.body.appendChild(link);
  link.click();
  setTimeout(() => document.body.removeChild(link), 500);
};

// Alias for print
export const printPdf = downloadPdf;

// Adds the auth token to a URL used directly by <img>/<a> (no axios headers there)
export const withToken = (url) => {
  let atelierToken = '';
  try { atelierToken = JSON.parse(localStorage.getItem('atelier_employee') || '{}').token || ''; } catch {}
  const onAtelier = window.location.pathname.startsWith('/atelier') && atelierToken;
  const token = onAtelier ? atelierToken : (localStorage.getItem('admin_token') || localStorage.getItem('superadmin_token') || localStorage.getItem('employee_token') || atelierToken || '');
  return `${url}${url.includes('?') ? '&' : '?'}token=${encodeURIComponent(token)}`;
};

export default api;